import { Hidden } from '@material-ui/core';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React from 'react';
import Logo from '../components/Logo';
import { PrivateHeaderProps, mapDispatchToProps, mapStateToProps } from './private-header.scheme';
import useStyles from '../header.styles';
import BackOrMenuBtn from 'components/BackOrMenuBtn';
import { headerComponentBtn } from 'features/Notifications';
import { useLocation } from 'react-router-dom';
import NetworkConnectionMessage from 'components/NetworkConnectionMessage';
import { mixPanelEventsTypes } from 'helpers/mixPanel';
import ChallengeHeaderSelect from 'features/prop/components/ChallengeHeaderSelect';
import { Pages } from 'interfaces/main';
import StartNewChallengeBtn from 'features/prop/components/StartNewChallengeBtn';
import { useHideStartChallengeButton } from 'features/prop/hooks/useHideStartChallengeButton';
import RetryChallengeBtn from 'features/prop/components/RetryChallengeBtn';
import { useTranslation } from 'react-i18next';
import WtTradeBtn from 'features/prop/components/WtTradeBtn';
import { useDisplayTradeNowButton } from 'features/prop/hooks/useDisplayTradeNowButton';
import { useEnableRetryButton } from 'features/prop/hooks/useEnableRetryButton';
import { useValidChallenges } from 'features/prop/hooks/useValidChallenges';
import LanguageSelect from 'components/SideMenu/components/LanguageSelect';
import analyticsManager from 'helpers/analyticsManager';
import KeepChallengeBtn from 'features/prop/components/KeepChallengeBtn';
import { useEnableKeeperButton } from 'features/prop/hooks/useEnableKeeperButton';
import config from 'config/common';
import { WnstnWrapper, WnstnTriggerButton } from 'features/wnstn-widget';

const PrivateHeader: React.FunctionComponent<PrivateHeaderProps> = (props) => {
    const {
        user_accountType,
        system_toggleSideMenu,
        user_fullName,
        system_selectorDeviceTypeSize,
        menuState,
        selectedChallenge,
        isUserDataComplete,
    } = props;
    const classes = useStyles();
    const location = useLocation();
    const { t } = useTranslation('prop');
    const hideStartChallengeButton = useHideStartChallengeButton();
    const displayTradeNowButton = useDisplayTradeNowButton();
    const [networkConnectionStateSelector, networkConnectionState] = React.useState<boolean>(true);
    const { isRetryActive: enableRetryButton } = useEnableRetryButton();
    const {
        isKeeperActive: enableKeeperButton,
        displayExtendMyLimit,
        selectedKeeperChallenge,
        selectedKeeperPlan,
    } = useEnableKeeperButton({
        challengeId: selectedChallenge?.id ?? '',
        planId: selectedChallenge?.plan ?? '',
    });

    React.useEffect(() => {
        const networkDisconnected = (status: boolean) => {
            analyticsManager.trackEvent(mixPanelEventsTypes.NETWORK_CONNECTION, { connectionStatus: 'disconnected' });
            networkConnectionState(status);
        };
        const networkConnected = (status: boolean) => {
            analyticsManager.trackEvent(mixPanelEventsTypes.NETWORK_CONNECTION, { connectionStatus: 'connected' });
            networkConnectionState(status);
        };
        window.addEventListener('online', () => networkConnected(window.navigator.onLine));
        window.addEventListener('offline', () => networkDisconnected(window.navigator.onLine));
    }, []);

    const isPlatformPage = location.pathname.includes(`/${Pages.PLATFORMS}`);

    const validChallenges = useValidChallenges();

    return (
        <div className={classes.header_private_wrapper}>
            <React.Fragment>
                {!networkConnectionStateSelector && <NetworkConnectionMessage />}
                <header
                    className={classnames(
                        classes.header_container__private,
                        !isUserDataComplete && classes.header_without_border
                    )}
                >
                    <Hidden smUp>
                        <BackOrMenuBtn
                            deviceSize={system_selectorDeviceTypeSize}
                            accountName={user_fullName}
                            toggleSideMenu={system_toggleSideMenu}
                        />
                    </Hidden>
                    <Logo isPrivate={true} id="mainLogo" alwaysShow={!isUserDataComplete} />
                    {isPlatformPage && isUserDataComplete && <ChallengeHeaderSelect challenges={validChallenges} />}
                    <div className={classes.header_right_group}>
                        {isUserDataComplete && (
                            <Hidden xsDown>
                                {enableRetryButton && isPlatformPage && <RetryChallengeBtn />}
                                {displayTradeNowButton && <WtTradeBtn />}
                                {!hideStartChallengeButton && (!isPlatformPage || !displayExtendMyLimit) && (
                                    <StartNewChallengeBtn label={t('prop_btn')} />
                                )}
                                {displayExtendMyLimit && (
                                    <KeepChallengeBtn challenge={selectedKeeperChallenge} plan={selectedKeeperPlan} />
                                )}
                            </Hidden>
                        )}
                        <WnstnWrapper>
                            <Hidden smUp>
                                <WnstnTriggerButton />
                            </Hidden>
                        </WnstnWrapper>
                        <Hidden xsDown={isUserDataComplete}>
                            <LanguageSelect menuState={menuState} />
                        </Hidden>
                        {isUserDataComplete && headerComponentBtn()}
                    </div>
                </header>
            </React.Fragment>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(PrivateHeader));
